// @flow

export const UPDATE_CHAT = "UPDATE_CHAT";
export const UPDATE_SOCIAL_NOTIFICATIONS_COUNT = "UPDATE_SOCIAL_NOTIFICATIONS_COUNT";
export const UPDATE_SOCIAL_FOLLOW_REQUEST_COUNT = "UPDATE_SOCIAL_FOLLOW_REQUEST_COUNT";
